import { QUERY_PARAMS } from './constants';

export const ACTION_TYPE = {
  SET_SEARCH_FORM: 'setSearchForm',
  RESET_SEARCH_FORM: 'resetSearchForm',
} as const;
type ActionType = typeof ACTION_TYPE[keyof typeof ACTION_TYPE];
type Payload = Partial<State>;
export interface Action {
  type: ActionType;
  payload: Payload;
}
export interface State {
  region: string;
  startDate: string;
  endDate: string;
  category: string;
  searchWord: string;
  term: string;
}

export const getInitialState = (urlSearchParams?: URLSearchParams): State => ({
  region: urlSearchParams?.get(QUERY_PARAMS.REGION) || '',
  startDate: urlSearchParams?.get(QUERY_PARAMS.START_DATE) || '',
  endDate: urlSearchParams?.get(QUERY_PARAMS.END_DATE) || '',
  category: urlSearchParams?.get(QUERY_PARAMS.CATEGORY) || '',
  searchWord: urlSearchParams?.get(QUERY_PARAMS.SEARCH_WORD) || '',
  term: urlSearchParams?.get(QUERY_PARAMS.TERM) || '',
});

const setStateWithDefaultValue = (
  payload: Payload,
  prevState: State,
): State => ({
  ...prevState,
  ...payload,
});
export const reducer = (state, { type, payload }) => {
  switch (type as ActionType) {
    case ACTION_TYPE.SET_SEARCH_FORM:
      return setStateWithDefaultValue(payload, state);
    case ACTION_TYPE.RESET_SEARCH_FORM:
      return setStateWithDefaultValue({}, getInitialState());

    default:
      return state;
  }
};
